/* Browser-owned navigation keeps Shopify/app initialization and history intact. */
(function(){
 var root=document.documentElement;
 var config=document.getElementById('om-page-navigation');
 if(!config)return;
 var mobile=matchMedia('(max-width:749px)'),reduced=matchMedia('(prefers-reduced-motion:reduce)'),bypass=false;
 function eligible(value){
  try{var url=new URL(value,location.href);return url.origin===location.origin&&/^https?:$/.test(url.protocol)&&!url.hash&&!/\/(checkout|checkouts|cart|account|challenge|password|apps|admin|policies)(\/|$)/.test(url.pathname)&&!url.searchParams.has('section_id')&&!url.searchParams.has('sections')}catch(e){return false}
 }
 function skip(){return reduced.matches||(mobile.matches&&config.dataset.mobile!=='true')||!eligible(location.href)}
 function log(message){if(config.dataset.debug==='true')console.debug('[POP navigation]',message)}
 document.addEventListener('click',function(e){
  var a=e.target.closest&&e.target.closest('a[href]');if(!a)return;
  bypass=e.defaultPrevented||e.button!==0||e.ctrlKey||e.metaKey||e.shiftKey||e.altKey||a.hasAttribute('download')||(a.target&&a.target!=='_self')||a.hasAttribute('data-no-transition')||a.hasAttribute('data-full-navigation')||!eligible(a.href);
 },true);
 addEventListener('pageswap',function(e){
  if(!e.viewTransition)return;
  var target=e.activation?.entry?.url;
  if(skip()||bypass||(target&&!eligible(target))){e.viewTransition.skipTransition();log('native navigation without animation')}else log('outgoing native transition');
 });
 addEventListener('pagereveal',function(e){
  var from=window.navigation?.activation?.from?.url;
  if(e.viewTransition&&(skip()||(from&&!eligible(from))))e.viewTransition.skipTransition();
  bypass=false;log('document ready; browser retains normal history and scroll restoration');
 });
 addEventListener('pageshow',function(){bypass=false});
})();
